import { AxiosError } from 'axios';

import { selectOrganisationInfos } from '@/domain/organisation/organisation.selectors';
import { ProjectTour } from '@/domain/project-tour/entities/project-tour.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { getProjectsTour } from './get-projects-tour.action';

type Params = {
  project: ProjectTour;
};

export const createProjectTour = createAppAsyncThunk(
  'projectTour/createProjectTour',
  async (
    params: Params,
    { extra: { projectTourGateway, snackbarGateway }, dispatch, getState },
  ): Promise<void> => {
    const organisationInfos = selectOrganisationInfos(getState());
    try {
      params.project.organisationId = organisationInfos.id;
      await projectTourGateway.create(params.project);
      showSnackbarSuccess(snackbarGateway);
      dispatch(getProjectsTour());
    } catch (error) {
      let errorMessageKey = translate('CreateProject.Message.error');
      if (error instanceof AxiosError && error.status === 402) {
        errorMessageKey = translate('CreateProject.Message.limited');
      }
      showSnackbarError(snackbarGateway, errorMessageKey);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('CreateProject.Message.success'));
}

function showSnackbarError(
  snackbarGateway: SnackbarGateway,
  errorMessage: string,
) {
  snackbarGateway.error(errorMessage);
}
